import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a1eeed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "connectionInner" }

import ProfileAvatar from "@/components/images/ProfileAvatar.vue";
import { ProfileAvatarSizeEnum } from "@/types/avatar";
interface CallAvatarProps {
  size: ProfileAvatarSizeEnum;
  src: string;
  isConnected: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CallAvatar',
  props: {
    size: { default: ProfileAvatarSizeEnum.Large },
    src: { default: "" },
    isConnected: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["connectionOuter", [_ctx.size, { isConnected: _ctx.isConnected }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ProfileAvatar, {
        src: _ctx.src,
        size: _ctx.size
      }, null, 8, ["src", "size"])
    ])
  ], 2))
}
}

})